import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import InquiryForm from "@/components/InquiryForm";
import BookingSection from "@/components/BookingSection";
import { Mail, Phone, MapPin, Clock, UploadCloud } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";

export default function ContactPage() {
  const { t } = useLang();
  const { content } = useContent();
  const company = content?.company || { email: "info@eazy-travels.com", phone: "+40 72 546 3917", address: "Bucharest, Romania" };

  return (
    <>
      <Header />
      <main className="bg-[var(--bg)]">
        <section className="pt-28 pb-12 bg-radial-gold border-b border-white/5">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <p className="overline mb-3">{t("contact.overline")}</p>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black text-white leading-tight mb-4">
              {t("contact.title")}
            </h1>
            <p className="text-white/65 max-w-2xl mx-auto text-lg">{t("contact.subtitle")}</p>
          </div>
        </section>

        <section className="py-20" data-testid="contact-form-section">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-10">
              <BookingSection variant="link" />
              <p className="overline-blue mt-8 mb-3">{t("booking.or")}</p>
              <h2 className="font-display text-3xl sm:text-4xl font-bold text-white">
                {t("contact.title")}
              </h2>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
              <div className="lg:col-span-2 space-y-5">
                <div className="card-dark p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 grid place-items-center rounded-full bg-[var(--gold)]/15 border border-[var(--gold)]/30">
                      <Mail size={18} className="text-[var(--gold)]" />
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-widest text-white/50 mb-1">Email</p>
                      <a href={`mailto:${company.email}`} className="text-white hover:text-[var(--gold)] font-medium" data-testid="contact-email">
                        {company.email}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="card-dark p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 grid place-items-center rounded-full bg-[var(--gold)]/15 border border-[var(--gold)]/30">
                      <Phone size={18} className="text-[var(--gold)]" />
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-widest text-white/50 mb-1">Phone</p>
                      <a href={`tel:${company.phone}`} className="text-white hover:text-[var(--gold)] font-medium">
                        {company.phone}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="card-dark p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 grid place-items-center rounded-full bg-[var(--gold)]/15 border border-[var(--gold)]/30">
                      <MapPin size={18} className="text-[var(--gold)]" />
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-widest text-white/50 mb-1">Office</p>
                      <p className="text-white font-medium">{company.address}</p>
                    </div>
                  </div>
                </div>
                <div className="card-dark p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 grid place-items-center rounded-full bg-[var(--gold)]/15 border border-[var(--gold)]/30">
                      <Clock size={18} className="text-[var(--gold)]" />
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-widest text-white/50 mb-1">Hours</p>
                      <p className="text-white font-medium">Mon — Fri · 09:00 – 18:00 EET</p>
                    </div>
                  </div>
                </div>
                <Link to="/documents" className="card-dark p-6 flex items-start gap-4 hover:border-[var(--gold)]/40 transition" data-testid="contact-documents-link">
                  <div className="w-11 h-11 grid place-items-center rounded-full bg-[var(--gold)]/15 border border-[var(--gold)]/30">
                    <UploadCloud size={18} className="text-[var(--gold)]" />
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-widest text-white/50 mb-1">Already have your files?</p>
                    <p className="text-white font-medium">Upload your documents here</p>
                  </div>
                </Link>
              </div>

              <div className="lg:col-span-3 card-dark p-6 sm:p-8">
                <InquiryForm />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
